import * as React from "react";
import { StateText } from "../framework/stateText";
import { stateGray, stateGreen, stateOrange, stateRed } from "../../models/consts";

interface IEventListStateChipProp {
    classes?: string;
    state: number;
    stateText: string;
}

export const EventListStateChip = (props: IEventListStateChipProp) => (
    <StateText
        classes={(props.classes ? props.classes + " " : "") + "event"}
        state={props.state}
        stateColor={props.state === 3
            ? stateGray
            : (props.state === 4
                ? stateRed
                : ((props.state === 5
                    ? stateOrange
                    : stateGreen)))
        }
        stateText={props.stateText}
    />
);
